module.exports = __webpack_public_path__ + "static/media/rocket.131c5635.svg";